"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var TxLocationSelectComponent = /** @class */ (function () {
    function TxLocationSelectComponent() {
        this.geonameId = 3469034;
        this.selectedLocation = '';
        this.txLocationName = new core_1.EventEmitter();
        this.locations = [
            'Acre',
            'Alagoas',
            'Amapá',
            'Amazonas',
            'Bahia',
            'Ceará',
            'Distrito Federal',
            'Espírito Santo',
            'Goiás',
            'Maranhão',
            'Mato Grosso',
            'Mato Grosso do Sul',
            'Minas Gerais',
            'Pará',
            'Paraíba',
            'Paraná',
            'Pernambuco',
            'Piauí',
            'Rio de Janeiro',
            'Rio Grande do Norte',
            'Rio Grande do Sul',
            'Rondônia',
            'Roraima',
            'Santa Catarina',
            'São Paulo',
            'Sergipe',
            'Tocantins'
        ];
    }
    TxLocationSelectComponent.prototype.ngOnInit = function () {
    };
    TxLocationSelectComponent.prototype.emitLocationName = function (name) {
        this.txLocationName.emit(name);
    };
    TxLocationSelectComponent.ctorParameters = function () { return []; };
    return TxLocationSelectComponent;
}());
exports.TxLocationSelectComponent = TxLocationSelectComponent;
//# sourceMappingURL=tx-location-select.component.js.map


// WEBPACK FOOTER //
// tx-location-select.component.js